import { render, staticRenderFns } from "./CurriculumListEECPure.vue?vue&type=template&id=27e13372&scoped=true&"
import script from "./CurriculumListEECPure.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListEECPure.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListEECPure.vue?vue&type=style&index=0&id=27e13372&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e13372",
  null
  
)

export default component.exports